






























import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import BaseComponent from './Base';

const ui = namespace('ui');

@Component
export default class NavMobileMenuSlider extends BaseComponent {
    public readonly $refs: {
        closeAllMenu: any,
    };

    protected heightStatic: number = 35;
    protected heightInStatic: string = '0';
    protected heightToHide: string = '0';
    protected innerHeightToHide: string = '0';
    protected showBackButton: boolean = false;

    protected mounted(): void {
        this.heightToHide = (window.innerHeight - 41) + 'px';
        this.innerHeightToHide = (window.innerHeight - 42) + 'px';
        this.heightInStatic = this.heightStatic + 'px';
        window.addEventListener('orientationchange', (event) => {
            setTimeout(() => {
                this.heightToHide = (window.innerHeight - 41) + 'px';
                this.innerHeightToHide = (window.innerHeight - 42) + 'px';
            }, 200);
        });
    }

    protected highlightOnClose() {
        const exitBtnNode = document.getElementById('close-btn');
        const exitBtn: HTMLElement = exitBtnNode as HTMLElement;
        exitBtn.style.backgroundColor = 'rgba(240, 215, 205, .6)';
        setTimeout(() => {
            exitBtn.style.backgroundColor = 'transparent';
        }, 200);
    }

    protected highlightOnBack() {
        const backBtnNode = document.getElementById('back-btn');
        const backBtn: HTMLElement = backBtnNode as HTMLElement;
        backBtn.style.backgroundColor = '#fae4cd';
        setTimeout(() => {
            backBtn.style.backgroundColor = 'transparent';
        }, 300);
        this.scrollToTop();
    }

    protected scrollToTop() {
        const scrollBlockNone = document.getElementsByClassName('slide-menu__submenu--active');
        if (scrollBlockNone[0]) {
            const scrollBlock: HTMLElement = scrollBlockNone[0] as HTMLElement;
            scrollBlock.scrollIntoView();
        }
    }

    /**
     * @param event
     * @protected
     */
    protected onClickOutside(event) {
        const openMenuElement = document.getElementById('open-menu');
        if (openMenuElement) {
            if (openMenuElement.offsetParent !== null) {
                const el = document.getElementById('tourcompass-menu');
                if (el) {
                    const slideMenu: HTMLElement = el as HTMLElement;
                    if (slideMenu.style.transform && slideMenu.style.transform === 'translateX(0%)') {
                        if (!event.target.parentElement.classList.contains('v-nav-mobile-slide')) {
                            const elem = this.$refs.closeAllMenu as HTMLElement;
                            elem.click();
                            this.scrollToTop();
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavMobileMenuSlider.vue